import React from "react";
import { connect } from "react-redux";
import { NavLink } from "reactstrap";
import Media from "react-media";
import "./ImageElement.css";
import { sourceTypes } from "../../../../../../constants/cms/sourceType";
import ArchiveContainer from "../../../../../../file/containers/ArchiveContainer";
import InlineCropper from "../../../../../../file/plugins/InlineCropper";
import { cmsActions } from "../../../../../../store/actions/cms/cms.action";

const defaultImage =
  "https://images.unsplash.com/photo-1517484030358-fd0cca3d33d0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60";

class ImageElement extends React.PureComponent {
  state = {
    editor: {},
    isMediaVaultOpen: false,
    isCropping: false,
    containerStyle: null,
    baseValue: 0,
    saveCrop: false,
    style: "",
    marginTop: 0,
    reRender: false,
    data: null,
    imageLoaded: false,
  };
  componentDidMount() {
    if (
      this.props.settings.style !== undefined &&
      this.props.settings.style.maxHeight !== undefined &&
      this.props.settings.style.maxHeight !== "unset"
    ) {
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
          baseValue: this.imgRef.clientHeight,
        },
      });
      if (
        this.props.type === "IMG" &&
        this.props.settings.type === "FULL" &&
        this.props.v === ""
      ) {
        this.props.onChange(
          this.props.settings.style.maxHeight + "px",
          "data.style.maxHeight"
        );
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.settings.style !== undefined &&
        this.props.settings.style.maxHeight !== undefined &&
        this.state.imageLoaded &&
        this.imgRef &&
        this.props.value !== prevProps.value) ||
      (this.props.settings.style !== undefined &&
        this.props.settings.style.maxHeight !== undefined &&
        this.state.imageLoaded &&
        this.imgRef &&
        this.props.settings.type !== prevProps.settings.type)
    ) {
      this.props.onChange(
        { width: this.imgRef.offsetWidth, height: this.imgRef.offsetHeight },
        "data.orgSize"
      );
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
          baseValue: this.imgRef.clientHeight,
        },
      });
      if (this.props.type === "IMG" && this.props.settings.type === "FULL") {
        if (this.props.value && this.props.value.toString().includes("cropped"))
          return;
        this.props.onChange(
          this.imgRef.clientHeight + "px",
          "data.style.maxHeight"
        );
      }
    }
  }
  handleOnChange = (value) => {
    this.props.onChange(value, "props.value", this.props.contentId);
  };
  changeImage = (url) => {
    this.setState(
      {
        isMediaVaultOpen: false,
      },
      () => {
        this.props.onChange(url, "props.value");
      }
    );
  };
  setImage = (url) => {
    const { dispatch } = this.props;
    dispatch(cmsActions.blockDeselect(true));
    this.handleOnChange(url);
    setTimeout(() => dispatch(cmsActions.blockDeselect(false)), 2000);
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  toggleCroppie = () => {
    if (!this.state.containerStyle) {
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
        },
        isCropping: !this.state.isCropping,
      });
    } else {
      this.setState({ isCropping: !this.state.isCropping });
    }
  };
  handleCropSave = (value) => {
    this.setState({ value: value }, () => {
      this.setImage(value);
      this.setState({ isCropping: false });
    });
  };
  handleImageLoaded = () => {
    this.setState({ imageLoaded: true });
  };
  imageAlignment = (pos) => {
    switch (pos) {
      case "center":
        return "0px auto 0px auto";
      case "right":
        return "0px 0px 0px auto";
      case "left":
        return "0px auto 0px 0px";
      default:
        return "0px auto 0px auto";
    }
  };
  setImageClassName = (type) => {
    switch (type) {
      case "ORIGINAL":
        return "";
      case "FULL":
        return "full--landscape";
      case "SQUARE":
        return "square--landscape";
      case "CIRCLE":
        return "circular--landscape";
      default:
        return "";
    }
  };
  setImageStyle = (settings, matches) => {
    return {
      display:
        settings.type !== "FULL" && settings.style ? "inline-flex" : "unset",
      maxHeight:
        settings.type === "FULL" &&
        !matches.small &&
        settings.style.maxHeight !== "unset"
          ? settings.style.maxHeight
          : "unset",
      height:
        settings.type !== "FULL" && settings.style
          ? settings.style.height
          : undefined,
      width:
        settings.type !== "FULL" && settings.style
          ? settings.style.width
          : "100%",
      margin:
        settings.type !== "FULL"
          ? this.imageAlignment(settings.alignment)
          : "unset",
    };
  };
  renderOverlay = (value, defaultImage) => {
    const { type } = this.props.settings;
    return (
      <div className="image-overlay">
        <span href="#" className="image-icon" title="image">
          <i
            onClick={this.toggleMediaVault}
            style={{ cursor: "pointer" }}
            className="fa fa-image"
          ></i>
          {value !== defaultImage && type !== "ORIGINAL" ? (
            <i
              onClick={this.toggleCroppie}
              style={{ cursor: "pointer" }}
              className="fa fa-crop"
            ></i>
          ) : null}
        </span>
      </div>
    );
  };
  render() {
    const { cms, template } = this.props;
    const { settings, type, value, contentId } = this.props;

    let v = "";
    if (!value && (type === "TEXT" || type === "BUTTON")) v = `<p>Text</p>`;
    else if (value === "" && type === "IMG") v = defaultImage;
    else v = value;

    return (
      <React.Fragment>
        <Media
          queries={{
            small: "(max-width: 599px)",
            medium: "(min-width: 600px) and (max-width: 1199px)",
            large: "(min-width: 1200px)",
          }}
        >
          {(matches) => (
            <React.Fragment>
              {!this.state.isCropping && (
                <div
                  className={`image-container responsive-col-image-alignment ${this.setImageClassName(
                    settings.type
                  )}`}
                  style={this.setImageStyle(settings, matches)}
                >
                  <NavLink
                    href={settings.actionLink || ""}
                    disabled={cms.editMode || !settings.actionLink}
                    style={{ padding: "0px" }}
                    className=""
                  >
                    <img
                      ref={(r) => (this.imgRef = r)}
                      onLoad={this.handleImageLoaded}
                      src={v}
                      className={`image-content ${
                        this.state.imageLoaded ? "unblur" : "blur"
                      }`}
                      alt="image"
                    />
                  </NavLink>
                  {cms.editMode ? this.renderOverlay(v, defaultImage) : null}
                </div>
              )}
              <div
                style={
                  this.state.isCropping
                    ? settings.type !== "FULL"
                      ? { margin: this.imageAlignment(settings.alignment) }
                      : undefined
                    : {
                        width: !this.state.isCropping && 0,
                        opacity: !this.state.isCropping && 0,
                        height: !this.state.isCropping && 0,
                        maxHeight:
                          settings.type !== "FULL" && settings.style
                            ? settings.style.height
                            : !settings.style
                            ? "unset"
                            : settings.style.maxHeight,
                      }
                }
              >
                <InlineCropper
                  display={this.state.isCropping}
                  url={v}
                  hideOverlay={this.state.isCropping}
                  bgColor={
                    template &&
                    template.template &&
                    template.template.content.content.backgroundColor
                  }
                  settings={settings}
                  containerStyle={this.state.containerStyle}
                  cancel={this.toggleCroppie}
                  parent={contentId}
                  isCropping={this.state.isCropping}
                  onSave={this.handleCropSave}
                />
              </div>
              {this.state.isMediaVaultOpen ? (
                <ArchiveContainer
                  isOpen={this.state.isMediaVaultOpen}
                  onUseSelected={this.setImage}
                  showLaunchBtn={false}
                  toggle={this.toggleMediaVault}
                />
              ) : null}
            </React.Fragment>
          )}
        </Media>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  let selectedElement = null;
  if (state.cms.enviroment === sourceTypes.TEMPLATE) {
    selectedElement = state.template.selectedElement;
  }
  if (state.cms.enviroment === sourceTypes.PAGE) {
    selectedElement = state.page.selectedElement;
  }
  if (state.cms.enviroment === sourceTypes.FORM) {
    selectedElement = state.form.selectedElement;
  }
  return {
    alert: state.alert,
    form: state.form,
    cms: state.cms,
    selectedElement,
    template: state.template,
    language: state.language,
    page: state.page,
  };
}
export default connect(mapStateToProps)(ImageElement);
